import { render, staticRenderFns } from "./SegmentsDetailsIcon.vue?vue&type=template&id=346598da&"
import script from "./SegmentsDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./SegmentsDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports